if (!customElements.get("shoppable-drawer")) {
  customElements.define(
    "shoppable-drawer",
    class ShoppableDrawer extends HTMLElement {
      // Static property to track if first hotspot has been opened
      static firstHotspotOpened = false;

      constructor() {
        super();
        this.eventsAdded = false;
        this.initilize();
      }

      initilize() {
        this.clickHandler = this.clickHandler.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.updateEventListeners = this.updateEventListeners.bind(this);
        this.deviceType = "";
        this.isOpen = this.dataset.open;
        this.body = document.querySelector("body");
        this.container = document.querySelector(".wt__shoppable-image");
        this.wrapper = document.querySelector(".wt__shoppable-image--wrapper");
        this.shoppableImagesBody = document.querySelectorAll(
          ".shoppable-image__body",
        );
        this.pageOverlay = document.querySelector(
          ".wt__shoppable-image--page-overlay",
        );
        this.productContent = this.querySelector(
          ".wt-dot__tooltip .wt-dot__link",
        );
        this.tooltip = this.querySelector(".wt-dot__tooltip");
        this.tooltipActiveClass = "wt-dot__tooltip--active";
        this.hotspotActiveClass = "wt-dot--active";

        this.button = this.querySelector(".wt-dot__circle");
        this.closeButton = document.querySelector(".wt-options__title svg");

        if (window.innerWidth < 900) this.updateEventListeners();
        this.addDotEventListeners();
      }

      connectedCallback() {
        this.updateEventListeners();
        window.addEventListener("resize", this.handleResize);
        
        // Open the first hotspot by default (only once)
        this.openFirstByDefault();
      }

      openFirstByDefault() {
        // Only open the first hotspot if none has been opened yet
        if (!ShoppableDrawer.firstHotspotOpened && this.tooltip) {
          ShoppableDrawer.firstHotspotOpened = true;
          // Small delay to ensure DOM is ready
          requestAnimationFrame(() => {
            this.showTooltip(this.tooltip);
          });
        }
      }

      addDotEventListeners() {
        if (this.eventsAdded) return;

        this.querySelectorAll(".wt-dot").forEach((link) => {
          link.addEventListener("click", this.handleDotClick);
          link.addEventListener("keydown", this.handleDotKeydown);
        });

        this.eventsAdded = true;
      }

      handleDotClick = (event) => {
        event.preventDefault();

        const dotElement = event.target.closest(".wt-dot");
        if (!dotElement) return;

        const tooltipElement = dotElement.nextElementSibling;
        if (
          !tooltipElement ||
          !tooltipElement.classList.contains("wt-dot__tooltip")
        ) {
          return;
        }

        this.toggleTooltip(tooltipElement);
      };

      handleDotKeydown = (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          this.toggleTooltip(event.srcElement.parentElement.nextElementSibling);
        }
      };

      toggleTooltip(tooltip) {
        // Close any other open tooltips first
        this.hideAllTooltips();
        // Always show the clicked tooltip (no toggle off behavior)
        this.showTooltip(tooltip);
      }

      hideAllTooltips() {
        const tooltips = document.getElementsByClassName("wt-dot__tooltip");
        Array.from(tooltips).forEach((tooltip) => {
          tooltip.classList.remove(this.tooltipActiveClass);

          const closestHotspot = tooltip
            .closest("[data-block-id]")
            ?.querySelector(".wt-dot");
          if (closestHotspot) {
            closestHotspot.classList.remove(this.hotspotActiveClass);
          }
        });
      }

      showTooltip(tooltip) {
        tooltip.classList.add(this.tooltipActiveClass);

        const closestHotspot = tooltip
          .closest("[data-block-id]")
          ?.querySelector(".wt-dot");
        if (closestHotspot) {
          closestHotspot.classList.add(this.hotspotActiveClass);
        }
      }

      handleResize = () => {
        this.updateEventListeners();
      };

      updateEventListeners() {
        if (
          this.matchResolution() === "mobile" &&
          this.matchResolution() != this.deviceType
        ) {
          if (this.button)
            this.button.addEventListener("click", this.clickHandler);
          if (this.button)
            this.button.addEventListener("keydown", this.enterKeyHandler);

          if (this.tooltip) this.tooltip.style.display = "none";
          if (this.closeButton)
            this.closeButton.addEventListener("click", this.closeHandler);
          this.deviceType = this.matchResolution();
        } else if (
          this.matchResolution() === "desktop" &&
          this.matchResolution != this.deviceType
        ) {
          if (this.button)
            this.button.removeEventListener("click", this.clickHandler);
          if (this.button)
            this.button.removeEventListener("keydown", this.enterKeyHandler);
          this.closeHandler();
          if (this.tooltip) this.tooltip.style.display = "initial";
          this.deviceType = this.matchResolution();
        }
      }

      enterKeyHandler = (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          this.clickHandler(event);
        }
      };

      clickHandler() {
        this.wrapper.querySelectorAll(".wt-dot__link")?.forEach((element) => {
          element.remove();
        });
        this.body.classList.add("shoppable-image-on");
        this.isOpen = true;
        this.pageOverlay.classList.remove("hidden");
        const productContentClone = this.productContent.cloneNode(true);
        this.wrapper.appendChild(productContentClone);
        this.wrapper.classList.add("open");
      }

      closeHandler() {
        if (this.body.classList.contains("shoppable-image-on"))
          this.body.classList.remove("shoppable-image-on");
        if (!this.pageOverlay.classList.contains("hidden"))
          this.pageOverlay.classList.add("hidden");
        if (this.wrapper.classList.contains("open"))
          this.wrapper.classList.remove("open");

        this.hideAllTooltips();
      }

      matchResolution() {
        if (window.innerWidth < 900) {
          return "mobile";
        } else {
          return "desktop";
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.clickHandler);
        this.closeButton?.removeEventListener("click", this.closeHandler);
        window.removeEventListener("resize", this.handleResize);
      }
    },
  );
}
